import React, { useMemo } from "react";
import "./styles/FloatingLightbulb.css";

interface FloatingLightbulbProps {
  isDark: boolean;
  toggleTheme: () => void;
}

const FloatingLightbulb: React.FC<FloatingLightbulbProps> = ({ isDark, toggleTheme }) => {
  const icon = useMemo(() => isDark ? "💡" : "🌌", [isDark]);
  const tooltip = useMemo(() => isDark ? "Switch to Light Mode" : "Switch to Dark Mode", [isDark]);

  return (
    <button
      className="lightbulb-wrapper"
      onClick={toggleTheme}
      aria-label={tooltip}
    >
      <div className="lightbulb-tooltip">{tooltip}</div>
      <div className={`lightbulb-icon ${isDark ? "lit" : "sky"}`}>
        {icon}
      </div>
    </button>
  );
};

export default FloatingLightbulb;